
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface EmailParticipant {
  email: string;
  name?: string;
}

export interface EmailConversation {
  id: string;
  subject?: string;
  participants?: EmailParticipant[];
  last_message_date: string;
  unread_count: number;
  status?: string;
  user_id: string;
}

export const useEmailConversations = () => {
  return useQuery({
    queryKey: ['email-conversations'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('email_conversations')
        .select(`
          id,
          subject_normalized,
          participant_emails,
          last_email_at,
          status,
          user_id,
          first_email_at,
          overall_priority_score
        `)
        .order('last_email_at', { ascending: false });

      if (error) {
        console.error('Error fetching email conversations:', error);
        return [];
      }

      // Transform the data to match the expected interface
      const conversations: EmailConversation[] = (data || []).map(conv => ({
        id: conv.id,
        subject: conv.subject_normalized || "No Subject",
        participants: (conv.participant_emails as string[] || []).map(email => ({ email })),
        last_message_date: conv.last_email_at || new Date().toISOString(),
        unread_count: 0, // This would need to be calculated based on actual email data
        status: conv.status || 'open',
        user_id: conv.user_id
      }));

      return conversations;
    },
  });
};
